import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import LoadingSpinner from 'components/LoadingSpinner';
import FeedLoader from 'components/FeedLoader';
import { AuthSession, useAuthSession } from '@spins/react-sso-provider';
import { hamburgerMenuItemsSelector } from 'containers/AccessControl/selectors';
import { clientIdSelector } from 'store/global/selectors';
import { HamburgerMenuType } from 'utils/types';
import AccessControlUtils from 'utils/access-control';
import { getData } from 'utils/functions';
import { initApp } from 'containers/AccessControl/actions';
import { setIsWhiteListedForCampaign } from 'store/global/actions';
import { useHistory } from 'react-router';
import { useApolloClient } from '@apollo/client';
import {
  WhiteListedClientsDocument,
  WhiteListedClientsQueryVariables,
  WhiteListedClientsQuery
} from 'generated/campaigns-graphql';
import { campaignsClient } from 'apollo';

const AppInit = () => {
  const authSession: AuthSession = useAuthSession();
  const dispatch = useDispatch();
  const history = useHistory();
  const client = useApolloClient();
  const clientId: string = useSelector(clientIdSelector);
  const hamburgerMenu: Array<HamburgerMenuType> = useSelector(hamburgerMenuItemsSelector);

  useEffect(() => {
    dispatch(initApp(authSession, client, history));
  }, [authSession, client, dispatch, history]);

  const { data } = useQuery<WhiteListedClientsQuery, WhiteListedClientsQueryVariables>(
    WhiteListedClientsDocument,
    {
      client: campaignsClient
    }
  );

  useEffect(() => {
    if (data) {
      const isWhiteListed = AccessControlUtils.isWhiteListedForCampaign(clientId, getData(data));
      dispatch(setIsWhiteListedForCampaign(isWhiteListed));
    }
  }, [clientId, data, dispatch]);

  if (hamburgerMenu.length > 0) {
    // TODO: need a proper way to check that app init is done
    return <FeedLoader />;
  }

  return <LoadingSpinner centered />;
};

export default AppInit;
